module.exports = __webpack_public_path__ + "img/game--knockout-city.b7ac2889.png";